import { useQuery } from '@tanstack/react-query';
import { getBusinessPaymentsCapabilities } from '../../services/business';
import useUser from '../global/useUser';
import { isSudoManager } from '../../utils/global/helper';

function useBusinessCapabilities() {
  const { user } = useUser();

  return useQuery({
    queryKey: [
      'business-capabilities',
      user?.business?.id,
      user?.business?.type,
    ],
    queryFn: () => getBusinessPaymentsCapabilities(user!.business?.id),
    enabled:
      !!user?.business?.id &&
      isSudoManager(user) &&
      user?.business.type === 'STUDIO',
  });
}

export default useBusinessCapabilities;
